const borderColor = '#e4e4e4';
const accentColor = '#a855f7';
const highlightColor = '#8B5CF60D';

const SelectStyles = {
  control: (provided, state) => ({
    ...provided,
    'height': 58,
    'boxShadow': 'none',
    'overflowY': 'auto',
    'border': `2px solid ${state.isFocused ? accentColor : borderColor}`,
    'fontSize': 14,
    'borderRadius': 8,
    'fontWeight': 400,
    'cursor': state.selectProps.isSearchable ? 'text' : 'pointer',
    '&:hover': {
      border: `2px solid ${accentColor}`,
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#999999',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
  option: (provided, state) => ({
    ...provided,
    'cursor': 'pointer',
    'color': state.isSelected ? accentColor : provided.color,
    'backgroundColor': state.isSelected || state.isFocused ? highlightColor : provided.backgroundColor,
    '&:active': {
      backgroundColor: highlightColor,
    },
    'svg': {
      path: {
        fill: state.isSelected ? 'white' : provided?.svg?.path?.fill,
      },
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    fontSize: 14,
    backgroundColor: accentColor,
    color: '#ffffff',
    borderRadius: 4,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorContainer: (provided) => ({
    ...provided,
    width: '30px',
    padding: '3px',
  }),
};

export default SelectStyles;
